import { del, get, post } from "./api";

export async function getEventNotificationCounts() {
    return await get("event-notifications/unread-count");
}

export async function getUnreadEventNotifications(maxItems = 10) {
    return await get(`event-notifications/unread?maxItems=${maxItems}`);
}

export async function getRecentEventNotifications(maxItems = 10) {
    return await get(`event-notifications/recent?maxItems=${maxItems}`);
}

export async function markRecentEventNotificationsRead(maxItems = 10) {
    return await post({}, `event-notifications/read-recent?maxItems=${maxItems}`);
}


export async function deleteRecentEventNotifications(maxItems = 10) {
    return await del(`event-notifications/recent?maxItems=${maxItems}`);
}
